// Modules
import { useFormContext } from "react-hook-form"

// Constants
import { ERROR_MESSAGES } from "~constants/errorMessages"

// Components
import ImageUpload from "~components/imageUpload/ImageUpload"
import { WizardStepContainer, WizardRow } from "~styled/wizard"

interface StepProps {
  visible?: boolean
}

const CompanyModalStep3 = ({ visible = true }: StepProps) => {
  const { formState: { errors }, register, setValue, getValues, unregister } = useFormContext()

  return (
    <WizardStepContainer className={visible ? "visible" : ""}>
      <WizardRow style={{ marginBottom: 30 }}>
        <ImageUpload
          className={"logo"}
          key="logo"
          name="logo"
          label="Import Logo"
          required={true}
          customErrorMessage={errors.logo && ERROR_MESSAGES.FIELD_REQUIRED}
          {...{ register, setValue, getValues, unregister }}
          removeIcon={false}
        />
      </WizardRow>
      <WizardRow>
        <ImageUpload
          className={"cover"}
          key="cover"
          name="cover"
          label="Select your cover image"
          required={false}
          {...{ register, setValue, getValues, unregister }}
        />
      </WizardRow>
    </WizardStepContainer>
  )
}

export default CompanyModalStep3
